import React from "react";
import Marquee from "react-fast-marquee";

const tokens = ["AV Integration", "Business Wi-Fi", "Digital Signage", "Menu Boards", "POS Coordination", "Cable Management", "Preventive Support"];

export default function EditorialMarquee() {
    return (
        <section data-testid="marquee" className="border-t border-b border-line py-8 md:py-10 bg-bg">
            <Marquee gradient={false} speed={40} pauseOnHover>
                {Array.from({ length: 2 }).flatMap((_, k) =>
                    tokens.map((t, i) => (
                        <span key={`${k}-${i}`} className="flex items-center gap-8 pr-10">
                            <span className="font-display text-5xl md:text-7xl tracking-tight stroke-heading">{t}</span>
                            <span className="w-2 h-2 rounded-full bg-gold" />
                        </span>
                    ))
                )}
            </Marquee>
        </section>
    );
}
